export const funds = [
  {
    id: 'zpim',
    path: '/zp-india-master-trust',
    name: 'Zephyr Peacock India Master Trust',
    investmentManager: 'ZP India Advisory Private Limited',
    category: 'Category I',
    sebi: 'IN/AIF1/25-26/1965',
    scoresId: 'AIFN00543',
  },
  {
    id: 'zpait',
    path: '/zp-alternative-investment-trust',
    name: 'Zephyr Peacock Alternative Investment Trust',
    investmentManager: 'ZP India Advisory Private Limited',
    category: 'Category II',
    sebi: 'IN/AIF2/17-18/0377',
    scoresId: 'AIF00172',
  },
  {
    id: 'zpait2',
    path: '/zp-alternative-investment-trust-ii',
    name: 'Zephyr Peacock Alternative Investment Trust II',
    investmentManager: 'ZP India Advisory Private Limited',
    category: 'Category II',
    sebi: 'IN/AIF2/23-24/1483',
    scoresId: 'AIFN00028',
  },
];

export const complianceOfficer = 'Nikhil Sultania';
